var _circle, _path, _rect, _rect2, _g, _path2, _path3, _g2, _path4, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLocked = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 168 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 84,
    cy: 94,
    r: 84,
    fill: "#EFF8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54 30.8635V8C54 3.58172 57.5817 0 62 0H106C110.418 0 114 3.58172 114 8V30.8635C114 33.1556 113.344 35.3997 112.108 37.3304L108.922 42.3113C107.452 44.6095 104.911 46 102.183 46H65.8171C63.0887 46 60.5485 44.6095 59.0781 42.3113L55.8916 37.3304C54.6564 35.3997 54 33.1556 54 30.8635Z",
    fill: "url(#paint0_linear_9236_27168)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 90,
    width: 12,
    height: 46,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.3,
    x: 66,
    width: 12,
    height: 46,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dddi_9236_27168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72.0435 34.8697C79.447 30.616 88.553 30.616 95.9564 34.8697L128.956 53.8302C136.407 58.1108 141 66.0476 141 74.6399V112.36C141 120.952 136.407 128.889 128.956 133.17L95.9564 152.13C88.553 156.384 79.447 156.384 72.0435 152.13L39.0436 133.17C31.5934 128.889 27 120.952 27 112.36V74.6399C27 66.0476 31.5934 58.1108 39.0436 53.8302L72.0435 34.8697Z",
    fill: "url(#paint1_radial_9236_27168)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.6102 40.0226L88.1271 84.0362L114.662 48.3334C120.582 52.3157 125.684 57.4184 129.667 63.3376L93.9639 89.8728L137.977 83.3898C138.648 86.8229 139 90.3704 139 94C139 97.6296 138.648 101.177 137.977 104.61L93.9639 98.1272L129.667 124.662C125.684 130.582 120.582 135.684 114.662 139.667L88.1271 103.964L94.6102 147.977C91.177 148.648 87.6296 149 84 149C80.3704 149 76.8229 148.648 73.3898 147.977L79.8729 103.964L53.3375 139.667C47.4183 135.684 42.3157 130.582 38.3334 124.662L74.0362 98.1272L30.0226 104.61C29.3516 101.177 29 97.6296 29 94C29 90.3704 29.3516 86.8229 30.0226 83.3898L74.0362 89.8728L38.3334 63.3376C40.3145 60.3928 42.573 57.6501 45.0714 55.1469C45.0966 55.1217 45.1217 55.0965 45.147 55.0713C47.6502 52.573 50.3929 50.3145 53.3376 48.3334L79.8728 84.0361L73.3898 40.0226C76.8229 39.3516 80.3704 39 84 39C87.6296 39 91.177 39.3516 94.6102 40.0226ZM86.9716 86.8261L91.1739 91.0284V96.9716L86.9716 101.174H81.0285L76.8261 96.9715V91.0285L81.0285 86.8261H86.9716Z",
    fill: "white",
    fillOpacity: 0.2
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0363 38.338C80.2058 34.7932 87.7942 34.7932 93.9637 38.338L126.964 57.2985C133.172 60.8657 137 67.4797 137 74.6399V112.36C137 119.52 133.172 126.134 126.964 129.701L93.9637 148.662C87.7941 152.207 80.2058 152.207 74.0363 148.662L41.0363 129.701C34.8278 126.134 31 119.52 31 112.36V74.6399C31 67.4797 34.8278 60.8657 41.0363 57.2985L74.0363 38.338Z",
    stroke: "url(#paint2_linear_9236_27168)",
    strokeWidth: 8
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_di_9236_27168)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M104 83.6106H100V78.1731C100 69.2779 92.8 62 84 62C75.2 62 68 69.2779 68 78.1731V83.6106H64C62 83.6106 60 85.6322 60 87.6538V115.957C60 117.978 62 120 64 120H104C106 120 108 117.978 108 115.957V87.6538C108 85.6322 106 83.6106 104 83.6106ZM88 111.913H80L81.6 103.018C79.6 102.21 78 99.7837 78 97.762C78 94.5274 80.8 91.6971 84 91.6971C87.2 91.6971 90 94.5274 90 97.762C90 100.188 88.8 102.21 86.4 103.018L88 111.913ZM92 83.6106H76V78.1731C76 73.7255 79.6 70.0865 84 70.0865C88.4 70.0865 92 73.7255 92 78.1731V83.6106Z",
    fill: "url(#paint3_linear_9236_27168)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9236_27168",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 31,
    width: 114,
    height: 125
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0363 38.338C80.2058 34.7932 87.7942 34.7932 93.9637 38.338L126.964 57.2985C133.172 60.8657 137 67.4797 137 74.6399V112.36C137 119.52 133.172 126.134 126.964 129.701L93.9637 148.662C87.7941 152.207 80.2058 152.207 74.0363 148.662L41.0363 129.701C34.8278 126.134 31 119.52 31 112.36V74.6399C31 67.4797 34.8278 60.8657 41.0363 57.2985L74.0363 38.338Z",
    stroke: "url(#paint4_linear_9236_27168)",
    strokeWidth: 8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9236_27168)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -135.116,
    y: -18.6541,
    width: 66,
    height: 342.147,
    transform: "rotate(-30 -135.116 -18.6541)",
    fill: "url(#paint5_linear_9236_27168)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dddi_9236_27168",
    x: 7,
    y: 19.6794,
    width: 154,
    height: 163.641,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.696007 0 0 0 0 0.829975 0 0 0 0 0.879167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9236_27168"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.662812 0 0 0 0 0.793681 0 0 0 0 0.841667 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_9236_27168",
    result: "effect2_dropShadow_9236_27168"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_9236_27168",
    result: "effect3_dropShadow_9236_27168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_9236_27168",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.534688 0 0 0 0 0.648875 0 0 0 0 0.725 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect4_innerShadow_9236_27168"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_di_9236_27168",
    x: 40,
    y: 50,
    width: 88,
    height: 98,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.495226 0 0 0 0 0.63559 0 0 0 0 0.729167 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9236_27168"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9236_27168",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_9236_27168"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9236_27168",
    x1: 84,
    y1: 0,
    x2: 84,
    y2: 46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C3DAE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21875,
    stopColor: "#DDECF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.442708,
    stopColor: "#C3DAE9"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9236_27168",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84 76) rotate(90) scale(58 50.4733)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3F4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BFDAEC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9236_27168",
    x1: 84,
    y1: 28,
    x2: 84,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E9F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9236_27168",
    x1: 84,
    y1: 67,
    x2: 84,
    y2: 120,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEF9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CEE6F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9236_27168",
    x1: 84,
    y1: 28,
    x2: 84,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D5E9F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9236_27168",
    x1: -135.116,
    y1: 167.797,
    x2: -69.1157,
    y2: 167.797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53125,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLocked);
export default ForwardRef;